import {Component, EventEmitter, Input, OnInit, Output, signal, TemplateRef, WritableSignal} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {MultiSelectModule} from "primeng/multiselect";
import {PrimeTemplate} from "primeng/api";
import {TagModule} from "primeng/tag";
import {ToolbarModule} from "primeng/toolbar";
import {TooltipModule} from "primeng/tooltip";
import {TableModule} from "primeng/table";
import {LoginServices} from "../../../../../../auth/login/services/login.service";
import {ArchivoItem} from "../../../../../interfaces/proyecto.interface";
import {CheckboxModule} from "primeng/checkbox";
import {PrimeNgModule} from "../../../../../../shared/prime-ng/prime-ng.module";
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";

@Component({
    selector: 'app-archivo-vigente',
    standalone: true,
    imports: [
        DialogModule,
        MultiSelectModule,
        PrimeTemplate,
        TagModule,
        ToolbarModule,
        TooltipModule,
        TableModule,
        CheckboxModule,
        PrimeNgModule,
        IconFieldModule,
        InputIconModule
    ],
    templateUrl: './archivo-vigente.component.html',
    styleUrl: './archivo-vigente.component.scss'
})
export class ArchivoVigenteComponent implements OnInit {
    @Input() openDialog: boolean = false;
    @Input() datosCargados: boolean = false;
    @Input() archivoItems: ArchivoItem[] = [];
    @Input() loading!: TemplateRef<any>;
    @Output() onEventEmitterClose = new EventEmitter<boolean>;
    @Output() onEventEmitterLoad = new EventEmitter<boolean>;
    @Output() onEventEmitterFile = new EventEmitter<ArchivoItem[]>();
    /**
     * Lista de archivo seleccionado previamente
     */
    private _archivoSelect: WritableSignal<ArchivoItem[]> = signal([]);

    constructor(public loginServices: LoginServices) {
    }

    ngOnInit(): void {
    }

    onHideArchivos() {
        this.openDialog = false;
        this.onEventEmitterClose.emit(false);
    }

    isArchivoSeleccionado(hash: string): boolean {
        return this.archivoSelect().some(p => p.hash === hash);
    }

    onCheckboxChange(event: any, archivo: ArchivoItem) {
        event.originalEvent.stopPropagation();
        let check = event.checked;
        if (check) {
            this._archivoSelect.set([...this.archivoSelect(), archivo]);
        } else {
            this._archivoSelect.set(this.archivoSelect().filter(p => p.hash !== archivo.hash));
        }
        this.onEventEmitterFile.emit(this.archivoSelect())
        this.onEventEmitterClose.emit(false);
    }

    get archivoSelect(): WritableSignal<ArchivoItem[]> {
        return this._archivoSelect;
    }

    set archivoSelect(value: WritableSignal<ArchivoItem[]>) {
        this._archivoSelect = value;
    }
}
